import React, { useState } from 'react';
import { FileText, Receipt } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AideFacturationLocation from './AideFacturationLocation';
import FacturesLocation from './FacturesLocation';

const TABS = [
  { key: 'aide',     label: 'Aide à la facturation', Icon: FileText, right: null },
  { key: 'factures', label: 'Factures',               Icon: Receipt,  right: 'facturation_loc_factures' },
];

export default function FacturationTabs() {
  const loc = useLocation();
  const navState = loc.state || {};
  const { user, menuRights } = useAuth();
  const isAdmin = user?.role === 'super_admin' || user?.role === 'admin_org';
  const rights  = menuRights || [];

  const visibleTabs = TABS.filter(t =>
    !t.right || isAdmin || rights.includes(t.right)
  );

  const defaultTab = navState.initial_tab || (visibleTabs[0]?.key || 'aide');
  const [tab, setTab] = useState(defaultTab);
  const activeTab = visibleTabs.find(t => t.key === tab) ? tab : (visibleTabs[0]?.key || 'aide');

  return (
    <div className="flex flex-col" style={{ height: 'calc(100vh - 48px)', margin: '-24px', minHeight: 0 }}>
      {/* ── Barre d'onglets ── */}
      <div className="flex items-end gap-1 px-6 flex-shrink-0 border-b"
        style={{ borderColor: 'var(--border)', background: 'white', paddingTop: 10 }}>
        {visibleTabs.map(({ key, label, Icon }) => {
          const active = activeTab === key;
          return (
            <button
              key={key}
              data-testid={`tab-${key}`}
              onClick={() => setTab(key)}
              className="flex items-center gap-1.5 px-4 py-2.5 text-sm font-semibold transition-colors rounded-t-lg"
              style={{
                color:           active ? 'var(--primary-solid)' : 'var(--text-muted)',
                background:      active ? 'white' : 'transparent',
                borderBottom:    active ? '2px solid var(--primary-solid)' : '2px solid transparent',
                marginBottom:    active ? -1 : 0,
              }}>
              <Icon size={14} />
              {label}
            </button>
          );
        })}
      </div>

      {/* ── Contenu ── */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'aide'
          ? <AideFacturationLocation
              embedded
              initialContratId={navState.contrat_id}
              onFactureCreee={() => setTab('factures')}
            />
          : <FacturesLocation />}
      </div>
    </div>
  );
}
